import ListRfqContents from '../../../../../../client/src/rfq/src/viewmodel/ListRfqContentsViewModel';
import { DesBaseRfqIdRfqQuoteId } from '../utils/des-base-rfqId-quoteId-acc';

export default class DesListRfqContents extends DesBaseRfqIdRfqQuoteId {

    constructor() {
        console.log('DesRfqContents invoked');
        super(ListRfqContents);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfqIdRfqQuoteId.observedAttributes];
    }
}
if (!window.customElements.get('des-list-rfq-contents')) {
    window.customElements.define('des-list-rfq-contents', DesListRfqContents);
}
